<template>
  <div>
    <div class="ml-5 mr-5 pb-4">
      <b-row class="mt-4">
        <b-col align-self="center">
          <h4>Zuschlags-Konfiguration</h4>
        </b-col>
      </b-row>
    </div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <b-row class="ml-4">
        <b-col cols="4">
          <label>Die Zuschläge werden basieren auf den folgenden Lohnbestandteilen
            berechnet:</label>
        </b-col>
      </b-row>
      <b-row class="mt-2 ml-4">
        <b-col
          cols="auto"
          align-self="center"
        >
          <label>Basisstundenlohn</label>
        </b-col>
        <b-col
          cols="auto"
          align-self="center"
        >
          <label>+</label>
        </b-col>
        <b-col cols="3">
          <v-autocomplete
            :disabled="!canUserEdit"
            :items="relevantSupplementOptions"
            :value="selectedRelevantSupplements"
            class="ml-4"
            clearable
            item-text="text"
            item-value="value"
            multiple
            placeholder="Relevante Zuschläge"
            @input="setRelevantSupplement($event)"
          />
        </b-col>
      </b-row>
      <hr class="mt-4">
      <div class="ml-5 mr-5 pb-4">
        <b-row class="mt-4">
          <b-col
            cols="3"
            align-self="center"
          >
            <h4>Zuschlagstypen-Definitionen</h4>
          </b-col>
          <b-col
            class="pt-2"
            cols="1"
          >
            <span>Zuschlagstypen kumulieren</span>
          </b-col>
          <b-col
            class="pt-2"
            cols="1"
          >
            <v-checkbox
              v-if="zuschlagsDefinitionen && zuschlagsDefinitionen.length > 0"
              v-model="compundWageSupplement"
              :disabled="!canUserEdit"
              color="#e72b37"
              hide-details
              class="mt-0"
              @change="SaveWageSupplementCompounding"
            />
          </b-col>
          <b-col
            cols="auto"
            class="ml-auto"
          >
            <v-btn
              v-if="canUserEdit"
              color="success"
              style="min-width: 150px; max-width: 200px"
              tile
              @click="addEmptyDefinition"
            >
              <i class="fas fa-plus mr-3" /> Erfassen
            </v-btn>
          </b-col>
        </b-row>
      </div>
      <div
        v-for="(definition, definitionIndex) in zuschlagsDefinitionen"
        :key="definitionIndex"
        class="ml-4 pb-5 mr-4"
      >
        <v-card class="p-4 mt-4">
          <!--  ------------------ROW 1------------------------- -->
          <b-row class="mt-4">
            <b-col cols="1">
              <label class="float-right pt-4">Zuschlagstyp</label>
            </b-col>

            <b-col cols="1">
              <v-select
                v-model="definition.wageSupplementType"
                :disabled="!canUserEdit"
                :items="wageSupplementTypes"
                item-text="text"
                item-value="id"
              />
            </b-col>
            <b-col cols="1">
              <label class="pl-2 pt-4">Zeit Typ</label>
            </b-col>
            <b-col cols="1">
              <v-select
                v-model="definition.wageSupplementTimeType"
                :disabled="!canUserEdit"
                :items="wageSupplementTimeTypes"
                item-text="text"
                item-value="id"
                style="margin-left: -30%"
              />
            </b-col>
            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) === 'Uhr' &&
                  showWholeDayCheckBox(definition)
              "
              class="d-flex"
              cols="1"
            >
              <label class="pt-4">ganzer Tag</label>
              <v-checkbox
                v-model="definition.fullDay"
                :disabled="!canUserEdit"
                color="#e72b37"
                hide-details
                @change="resetFields(definition)"
              />
            </b-col>
            <b-col
              v-else
              cols="1"
            />
            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) === 'h' ||
                  !definition.fullDay
              "
              cols="auto"
            >
              <label class="pt-4">Ab</label>
            </b-col>

            <b-col
              v-if="showExtendendSelectors(definition) && !definition.fullDay"
              cols="1"
            >
              <!-- Needed for Sonntagsarbeitszeiten -->
              <v-select
                v-model="definition.dayOfFromHour"
                :disabled="!canUserEdit"
                :items="[
                  { text: 'des Tages', value: 1 },
                  { text: 'des Vortages', value: 2 },
                ]"
                item-text="text"
                item-value="value"
              />
            </b-col>

            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) === 'h' ||
                  !definition.fullDay
              "
              cols="1"
            >
              <v-text-field
                v-if="getTimeUnitOfDefinition(definition) === 'Uhr'"
                v-model="definition.fromTime"
                :disabled="!canUserEdit"
                class="textField"
                type="time"
              />
              <v-text-field
                v-else
                v-model="definition.fromHour"
                :disabled="!canUserEdit"
                class="textField"
                type="number"
              />
            </b-col>

            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) == 'h' ||
                  !definition.fullDay
              "
              cols="auto"
            >
              <label class="pt-4">
                {{ getTimeUnitOfDefinition(definition) }}
              </label>
            </b-col>

            <b-col cols="1">
              <label class="pt-4">Lohnzuschlag %</label>
            </b-col>
            <b-col cols="1">
              <v-text-field
                :disabled="!canUserEdit"
                type="number"
                :value="
                  definition.wageSupplmentPercent == null
                    ? 0
                    : definition.wageSupplmentPercent
                "
                @input="
                  (val) =>
                    (definition.wageSupplmentPercent =
                      val === '' || val == null ? 0 : Number(val))
                "
              />
            </b-col>
            <b-col cols="1">
              <label class="pt-4">Max. pro Monat</label>
            </b-col>
            <b-col cols="1">
              <v-text-field
                v-model="definition.maxMonth"
                :disabled="!canUserEdit"
                class="textField"
                type="number"
              />
            </b-col>
            <b-col
              class="pl-0 pr-0"
              cols="auto"
            >
              <label class="pt-4">h</label>
            </b-col>
          </b-row>
          <!--  ------------------ROW 2------------------------- -->
          <b-row>
            <b-col cols="1">
              <label class="pl-3 pt-4">Sommer-/ Winterzeit</label>
            </b-col>
            <b-col cols="1">
              <v-select
                v-model="definition.seasonalTimeType"
                :disabled="!canUserEdit"
                :items="seasonalTimeTypes"
                clearable
                item-text="text"
                item-value="id"
              />
            </b-col>
            <b-col
              v-if="showApplicableDays(definition)"
              cols="1"
            >
              <label class="pl-2 pt-4">Anwendbare Tage</label>
            </b-col>
            <b-col
              v-if="showApplicableDays(definition)"
              cols="1"
            >
              <v-select
                v-model="definition.applicableDays"
                :disabled="!canUserEdit"
                :items="applicableDaysTypes"
                clearable
                item-text="text"
                item-value="id"
              />
            </b-col>
            <b-col :cols="showApplicableDays(definition) ? 1 : 3" />
            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) === 'h' ||
                  !definition.fullDay
              "
              cols="auto"
            >
              <label class="pt-4">Bis</label>
            </b-col>

            <b-col
              v-if="showExtendendSelectors(definition) && !definition.fullDay"
              cols="1"
            >
              <v-select
                v-model="definition.dayOfToHour"
                :disabled="!canUserEdit"
                :items="[
                  { text: 'des Tages', value: 1 },
                  { text: 'des Folgetags', value: 2 },
                ]"
                item-text="text"
                item-value="value"
              />
            </b-col>

            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) === 'h' ||
                  !definition.fullDay
              "
              cols="1"
            >
              <v-text-field
                v-if="getTimeUnitOfDefinition(definition) === 'Uhr'"
                v-model="definition.toTime"
                :disabled="!canUserEdit"
                class="textField"
                type="time"
              />
              <v-text-field
                v-else
                v-model="definition.toHour"
                :disabled="!canUserEdit"
                class="textField"
                type="number"
              />
            </b-col>
            <b-col
              v-if="
                getTimeUnitOfDefinition(definition) == 'h' ||
                  !definition.fullDay
              "
              cols="auto"
            >
              <label class="pt-4">{{
                getTimeUnitOfDefinition(definition)
              }}</label>
            </b-col>
            <b-col cols="1">
              <label class="pt-4">Zeitzuschlag %</label>
            </b-col>
            <b-col cols="1">
              <v-text-field
                :disabled="!canUserEdit"
                type="number"
                :value="
                  definition.timeSupplmentPercent == null
                    ? 0
                    : definition.timeSupplmentPercent
                "
                @input="
                  (val) =>
                    (definition.timeSupplmentPercent =
                      val === '' || val == null ? 0 : Number(val))
                "
              />
            </b-col>
            <b-col cols="1">
              <label class="pt-4">Max. pro Jahr</label>
            </b-col>
            <b-col cols="1">
              <v-text-field
                v-model="definition.maxYear"
                :disabled="!canUserEdit"
                class="textField"
                type="number"
              />
            </b-col>
            <b-col
              class="pl-0 pr-0"
              cols="auto"
            >
              <label class="pt-4">h</label>
            </b-col>
          </b-row>
          <!--  ------------------ROW 3------------------------- -->
          <b-row>
            <b-col cols="1">
              <label class="pl-3 pt-4">Vorübergehend/ Dauernde</label>
            </b-col>
            <b-col cols="2">
              <v-select
                v-model="definition.workType"
                :disabled="!canUserEdit"
                :items="workTypeTypes"
                clearable
                item-text="text"
                item-value="id"
              />
            </b-col>
            <b-col
              v-if="definition.workType !== 1"
              cols="1"
            >
              <label class="pl-3 pt-4">Ab</label>
            </b-col>
            <b-col
              v-if="definition.workType !== 1"
              cols="1"
            >
              <v-text-field
                v-model="definition.workTypeLimit"
                :disabled="!canUserEdit"
                class="textField"
                type="number"
              />
            </b-col>
            <b-col
              v-if="definition.workType !== 1"
              cols="1"
            >
              <v-select
                v-model="definition.workTypeLimitType"
                :disabled="!canUserEdit"
                :items="
                  workTypeSuppTypeLimitTypes[definition.wageSupplementType]
                "
                clearable
                item-text="text"
                item-value="id"
              />
            </b-col>
          </b-row>
          <!--  ------------------ROW 4------------------------- -->
          <b-row class="mt-4">
            <b-col cols="1">
              <v-checkbox
                v-model="definition.compensationThroughFreetime"
                :disabled="!canUserEdit"
                class="float-right"
                color="#e72b37"
                hide-details
              />
            </b-col>

            <b-col cols="3">
              <label
                class="pt-4"
              >Kompensation durch Freizeit gleicher Dauer möglich</label>
            </b-col>

            <b-col cols="1">
              <div>
                <label class="pt-4">Übertragung von (max.)</label>
              </div>
            </b-col>
            <b-col cols="1">
              <v-text-field
                v-model="definition.transferMaxHour"
                :disabled="
                  !definition.compensationThroughFreetime || !canUserEdit
                "
                type="number"
              />
            </b-col>
            <b-col cols="auto">
              <label class="pt-4">Mehrstunden auf ein Arbeitskonto bis</label>
            </b-col>
            <b-col cols="1">
              <v-text-field
                v-model="definition.dayMonthToCompensate"
                :disabled="
                  !definition.compensationThroughFreetime || !canUserEdit
                "
                :mask="'##.##'"
                placeholder="DD.MM"
                return-masked-value
              />
            </b-col>
            <b-col cols="1">
              <v-select
                v-model="definition.toCompensateYear"
                :disabled="
                  !definition.compensationThroughFreetime || !canUserEdit
                "
                :items="compensateYearOptions"
                item-text="text"
                item-value="id"
                clearable
              />
            </b-col>

            <b-col cols="auto">
              <label class="pt-4">zu kompensieren</label>
            </b-col>
          </b-row>
          <!--  ------------------ROW 5 ------------------------- -->
          <div>
            <hr>
            <label class="pt-4">
              <b>Weitere Zuschläge</b>
            </label>

            <b-row>
              <b-col cols="*">
                <label class="pt-4 pl-4">Zeitbonus in Minuten</label>
              </b-col>
              <b-col cols="1">
                <v-text-field
                  v-model="definition.timeBonusMinute"
                  :disabled="!canUserEdit"
                  type="number"
                />
              </b-col>
              <b-col cols="*">
                <label class="pt-4 pl-4">Geldzuschlag pro</label>
              </b-col>
              <b-col cols="1">
                <v-select
                  v-model="definition.monetarySupplementTimeType"
                  :disabled="!canUserEdit"
                  :items="wageSupplementTimeTypes"
                  item-text="text"
                  item-value="id"
                />
              </b-col>
              <b-col cols="1">
                <v-text-field
                  v-model="definition.monetarySupplement"
                  :disabled="!canUserEdit"
                  type="number"
                />
              </b-col>
              <b-col cols="*">
                <label class="pt-4 pl-4">Pauschalbetrag </label>
              </b-col>
              <b-col cols="2">
                <v-select
                  v-model="definition.wageSupplementLumpSumTypeId"
                  :disabled="!canUserEdit"
                  :items="wageSupplementLumpSum"
                  item-text="lumpSumTypeName"
                  item-value="id"
                  clearable
                />
              </b-col>
              <b-col cols="1">
                <v-text-field
                  v-model="definition.lumpSum"
                  :disabled="!canUserEdit"
                  type="number"
                />
              </b-col>
              <b-col cols="*">
                <label class="pt-4 pl-4">pro</label>
              </b-col>
              <b-col cols="1">
                <v-select
                  v-model="definition.lumpSumTimeType"
                  :disabled="!canUserEdit"
                  :items="wageSupplementTimeTypes"
                  item-text="text"
                  item-value="id"
                  clearable
                />
              </b-col>
            </b-row>
          </div>

          <!--  ------------------ROW 6------------------------- -->
          <b-row
            align-h="end"
            class="pt-0 mt-5"
          >
            <b-col cols="auto">
              <DefinitionHinttext
                :zuschlags-configuration-id="wageSupplementConfigurationId"
                :type-definition-id="definition.id"
                :languages="
                  $store.state.mindestLohnKonfiguration.BasicContractInformation
                    .translatedLanguages
                "
                :can-user-edit="canUserEdit && definition.id !== 0"
              />
            </b-col>
            <b-col cols="4" />
            <b-col cols="auto">
              <v-btn
                v-if="canUserEdit"
                color="success"
                tile
                @click="SaveDefinition(definitionIndex)"
              >
                <i class="fas fa-save pr-2" />
                Speichern
              </v-btn>
            </b-col>
            <b-col cols="auto">
              <v-btn
                v-if="canUserEdit"
                color="#e72b37"
                style="color: white"
                tile
                @click="deleteDefinition(definitionIndex)"
              >
                <i class="fas fa-trash" />
              </v-btn>
            </b-col>
          </b-row>
        </v-card>
      </div>
    </div>
    <b-modal
      id="deleteWageSupplementTypeDefinition"
      ref="deleteWageSupplementTypeDefinition"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      size="lg"
      title="Zuschlagsdefinitionen löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diese Zuschlags-Definition löschen möchten
      </div>
      <b-button
        variant="success"
        @click="confirmDeleteDefinition"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant
        @click="hideModal('deleteWageSupplementTypeDefinition')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import {
  DeleteDefinition,
  LoadDefinitions,
  SaveDefinition,
  GetWageSupplementTypes,
  GetWageSupplementTimeTypes,
  SaveDefinitionCompounding,
  GetDefinitionCompounding,
  SaveDefinitionRelevancy,
  GetDefinitionRelevancy,
  GetSeasonalTimeTypes,
  GetApplicableDaysTypes,
  GetWorkTypeTypes,
  GetWorkTypeLimitTypes,
} from "../../../../../services/minimum.wage.services/zuschlagsrechner/definition";
import { GetWageSupplementLumpSum } from "@/services/wageSupplement.lumpSum.service";
import DefinitionHinttext from "./DefinitionHinttext.vue";

export default {
  components: {
    DefinitionHinttext,
  },
  mixins: [MinimumWageMixin],
  props: {
    wageSupplementConfigurationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      zuschlagsDefinitionen: [],
      wageSupplementTimeTypes: [],
      wageSupplementTypes: [],
      seasonalTimeTypes: [],
      applicableDaysTypes: [],
      workTypeTypes: [],
      workTypeLimitTypes: [],
      relevantSupplementOptions: [
        { text: "Anteil Ferienentschädigung", value: 1 },
        { text: "Anteil Feiertagsentschädigung", value: 2 },
        { text: "Anteil im 13. ML", value: 3 },
      ],
      compensateYearOptions: [
        { text: "Aktuelles Jahr", id: 1 },
        { text: "Folgejahr", id: 2 },
      ],
      selectedRelevantSupplements: [],
      compundWageSupplement: false,
      compoundRelevantAdditions: false,
      errorMessage: "In der Eingabe dürfen nur Zahlen eingegeben werden!",
      wageSupplementLumpSum: [],
    };
  },
  computed: {
    workTypeSuppTypeLimitTypes() {
      let result = {};
      if (!this.workTypeLimitTypes || !this.wageSupplementTypes) {
        return result;
      }
      this.wageSupplementTypes.forEach((type) => {
        result[type.id] = [];
        this.workTypeLimitTypes.forEach((limit) => {
          result[type.id].push({
            id: limit.id,
            text: `Einsätze ${limit.text}`,
          });
        });
      });

      return result;
    },
  },
  created() {
    this.LoadSupplementTypes();
    this.loadAllDefinitions();
    this.LoadWageSupplementCompounding();
    this.LoagWageSupplementRelevancy();
    this.loadWageSupplementLumpSum();
  },
  mounted() {
    this.$el.addEventListener("keydown", this.blockNegativeKey);
    this.$el.addEventListener("paste", this.blockNegativePaste);
    this.applyNonNegativeInputs();
  },
  updated() {
    this.applyNonNegativeInputs();
  },
  beforeDestroy() {
    this.$el.removeEventListener("keydown", this.blockNegativeKey);
    this.$el.removeEventListener("paste", this.blockNegativePaste);
  },
  methods: {
    // Number inputs are rendered by Vuetify and re-rendered dynamically, so the
    // restriction is applied centrally to all of them.
    applyNonNegativeInputs() {
      this.$el
        .querySelectorAll('input[type="number"]')
        .forEach((input) => input.setAttribute("min", "0"));
    },
    hasNegativeNumber(definition) {
      const numericFields = [
        "fromHour",
        "toHour",
        "wageSupplmentPercent",
        "timeSupplmentPercent",
        "maxMonth",
        "maxYear",
        "workTypeLimit",
        "transferMaxHour",
        "timeBonusMinute",
        "monetarySupplement",
        "lumpSum",
      ];
      return numericFields.some((field) => {
        const value = definition[field];
        return (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          Number(value) < 0
        );
      });
    },
    blockNegativeKey(event) {
      if (event.target.type === "number" && event.key === "-") {
        event.preventDefault();
      }
    },
    blockNegativePaste(event) {
      if (event.target.type !== "number") {
        return;
      }
      const text = (event.clipboardData || window.clipboardData).getData("text");
      if (text.includes("-")) {
        event.preventDefault();
      }
    },
    loadWageSupplementLumpSum() {
      GetWageSupplementLumpSum(
        (response) => {
          this.wageSupplementLumpSum = response;
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    resetFields(definition) {
      if (definition.fullDay) {
        definition.fromHour = null;
        definition.toHour = null;
        definition.fromTime = null;
        definition.toTime = null;
        definition.dayOfFromHour = null;
        definition.dayOfToHour = null;
      }
    },
    getWageSupplementDefinitionObject(definitionIndex) {
      let definitionsCopy = JSON.parse(
        JSON.stringify(this.zuschlagsDefinitionen),
      );

      let definition = definitionsCopy[definitionIndex];

      //If WorkType == 'vorübergehend' set limit to null
      if (definition.workType == 1) {
        definition.workTypeLimit = null;
        definition.workTypeLimitType = null;
      }

      return definition;
    },
    getTimeUnitOfDefinition(definition) {
      if (
        definition.wageSupplementType !== 1 &&
        definition.wageSupplementType !== 2 &&
        definition.wageSupplementType !== 10 &&
        definition.wageSupplementType !== 11
      ) {
        return "Uhr";
      }
      return "h";
    },
    isSundayWork(definition) {
      if (
        definition.wageSupplementType === 6 ||
        definition.wageSupplementType === 7
      ) {
        return true;
      } else {
        return false;
      }
    },
    showWholeDayCheckBox(definition) {
      if (
        definition.wageSupplementType !== 1 &&
        definition.wageSupplementType !== 2 &&
        definition.wageSupplementTimeType === 2
      ) {
        return true;
      }
      return false;
    },
    showExtendendSelectors(definition) {
      if (
        definition.wageSupplementTimeType === 2 &&
        definition.wageSupplementType !== 1 &&
        definition.wageSupplementType !== 2 &&
        definition.wageSupplementType !== 10 &&
        definition.wageSupplementType !== 11
      ) {
        return true;
      }
      return false;
    },
    showApplicableDays(definition) {
      if (
        definition.wageSupplementType === 5 ||
        definition.wageSupplementType === 6 ||
        definition.wageSupplementType === 7 ||
        definition.wageSupplementType === 8
      ) {
        return false;
      }
      return true;
    },
    setRelevantSelection(relevancyDto) {
      let selection = [];
      if (relevancyDto.ferienentschaedigungRelevant) {
        selection.push(1);
      }
      if (relevancyDto.feiertagsentschaedigungRelevant) {
        selection.push(2);
      }
      if (relevancyDto.mL13Relevant) {
        selection.push(3);
      }
      this.selectedRelevantSupplements = selection;
    },
    setRelevantSupplement(selection) {
      let newRelevancy = {
        ferienentschaedigungRelevant: false,
        feiertagsentschaedigungRelevant: false,
        mL13Relevant: false,
      };

      if (selection && selection.length > 0) {
        selection.forEach((val) => {
          switch (val) {
            case 1:
              newRelevancy.ferienentschaedigungRelevant = true;
              break;
            case 2:
              newRelevancy.feiertagsentschaedigungRelevant = true;
              break;
            case 3:
              newRelevancy.mL13Relevant = true;
              break;
            default:
              break;
          }
        });
      }

      SaveDefinitionRelevancy(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        newRelevancy,
        () => {
          this.LoagWageSupplementRelevancy();
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    addEmptyDefinition() {
      let newDefinitions = [];
      if (this.zuschlagsDefinitionen && this.zuschlagsDefinitionen.length > 0) {
        newDefinitions = [...this.zuschlagsDefinitionen];
      }
      newDefinitions.push({
        id: 0,
        wageSupplementConfigurationId: 0,
        wageSupplementType: 1,
        wageSupplementTimeType: 1,
        fullDay: false,
        fromHour: null,
        toHour: null,
        wageSupplmentPercent: 0,
        timeSupplmentPercent: 0,
        maxMonth: null,
        maxYear: null,
        compensationThroughFreetime: true,
        transferMaxHour: null,
        transferHourToCompensate: null,
        definitionToDelete: null,
        ferienentschaedigungRelevant: false,
        feiertagsentschaedigungRelevant: false,
        mL13Relevant: false,
      });
      this.zuschlagsDefinitionen = newDefinitions;
    },
    loadAllDefinitions() {
      this.isLoading = true;
      LoadDefinitions(
        this.contractId,
        this.versionId,
        this.editionId,
        //TODO change to configurationId
        this.editionId,
        this.wageSupplementConfigurationId,
        (response) => {
          this.zuschlagsDefinitionen = response;

          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SaveWageSupplementCompounding() {
      SaveDefinitionCompounding(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        this.compundWageSupplement,
        (response) => {
          this.compundWageSupplement = response;
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoadWageSupplementCompounding() {
      GetDefinitionCompounding(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        (result) => {
          this.compundWageSupplement = result;
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoagWageSupplementRelevancy() {
      GetDefinitionRelevancy(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        (result) => {
          this.setRelevantSelection(result);
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SaveDefinition(definitionIndex) {
      let definitionToSave =
        this.getWageSupplementDefinitionObject(definitionIndex);
      if (this.hasNegativeNumber(definitionToSave)) {
        this.errorObject = "Negative Werte sind nicht erlaubt!";
        return;
      }
      this.isLoading = true;
      this.errorObject = null;
      SaveDefinition(
        this.contractId,
        this.versionId,
        this.editionId,
        //TODO change to configurationId
        this.editionId,
        this.wageSupplementConfigurationId,
        definitionToSave.id,
        definitionToSave,
        () => {
          this.loadAllDefinitions();
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoadSupplementTypes() {
      GetWageSupplementTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.wageSupplementTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        },
      );
      GetWageSupplementTimeTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.wageSupplementTimeTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
      GetSeasonalTimeTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.seasonalTimeTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
      GetApplicableDaysTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.applicableDaysTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
      GetWorkTypeTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.workTypeTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
      GetWorkTypeLimitTypes(
        (response) => {
          Object.keys(response).forEach((key) => {
            this.workTypeLimitTypes.push({
              id: Number(key),
              text: response[key],
            });
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    deleteDefinition(definitionIndex) {
      this.definitionToDelete = this.zuschlagsDefinitionen[definitionIndex];
      this.showModal("deleteWageSupplementTypeDefinition");
    },
    confirmDeleteDefinition() {
      if (this.definitionToDelete.id !== 0) {
        this.isLoading = true;
        DeleteDefinition(
          this.contractId,
          this.versionId,
          this.editionId,
          //TODO change to configurationId
          this.editionId,
          this.wageSupplementConfigurationId,
          this.definitionToDelete.id,
          () => {
            this.isLoading = false;
          },
          (error) => {
            console.error(error);
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      }
      let definitionIndex = this.zuschlagsDefinitionen.indexOf(
        (definition) => definition.id === this.definitionToDelete.id,
      );
      this.zuschlagsDefinitionen.splice(definitionIndex, 1);
      this.hideModal("deleteWageSupplementTypeDefinition");
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  },
};
</script>

<style>
.fill-width {
  overflow-x: auto;
  flex-wrap: nowrap;
}

.custom-normal-textinput {
  width: 200px;
}

.custom-small-textinput {
  width: 75px;
}

.custom-small-textinput-right .v-text-field__slot input {
  text-align: right;
  width: 75px;
  padding-right: 5px;
}

.custom_hr2 {
  padding-top: 20px;
  height: 20px;
  width: 100%;
  height: 50px;
  margin-top: 0;
  border: 1px solid #d3d3d3;
  box-shadow: 0 5px 5px -5px #d3d3d3;
  margin: -50px auto 5px;
}
</style>
